import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Import vuex modules
import category from './modules/category';
import offer from './modules/offer';

export const store = new Vuex.Store({
    modules: {
        category,
        offer
    }
});
